import { render, staticRenderFns } from "./DataCorrectionreport.vue?vue&type=template&id=d89366a2"
import script from "./DataCorrectionreport.vue?vue&type=script&lang=js"
export * from "./DataCorrectionreport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports